<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of Prototypes</h3>
            </b-col>
        </b-row>

        <div class="overflow-auto">

            <b-form-group label="Filter by name" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_prototype" type="search"
                        placeholder="Type to Search" v-on:keyup.enter="download_list_of_prototypes"></b-form-input>
                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by uuid" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_uuid" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_prototypes"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-button class="mb-3" @click="download_list_of_prototypes" variant="primary">Filter</b-button>

            <b-button class="ml-1 mb-3" variant="success" v-b-modal.modalPopover>New prototype</b-button>

            <b-table id="my-table" :items="prototypes" :per-page="perPage" :current-page="currentPage" :fields="fields"
                small striped>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/prototype/' + data.item.uuid">{{ data.value }}</router-link>
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage" align="fill" size="sm"
                class="my-0"></b-pagination>
        </div>

        <b-modal id="modalPopover" title="New prototype generation" hide-footer>
            <form ref="form" @submit.stop.prevent="createNewPrototype">
                <b-form-group label="Prototype name (min. 3 character)" label-for="new-prototype-name"
                    label-cols-sm="6" label-size="sm" class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="new-prototype-name" v-model="newPrototypeName"
                            v-on:keyup.enter="createNewPrototype" required v-slugify :disabled="uploading_in_progress"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <div role="group" class="form-row form-group mb-0" id="__BVID__170">
                    <label for="" class="col-sm-6 col-form-label col-form-label-sm">Resource file</label>
                    <input class="col-sm-6 col-form-label col-form-label-sm" type="file" ref="res_file"
                        accept="application/zip" :disabled="uploading_in_progress"/>
                </div>
            </form>
            <div class="d-flex justify-content-center mb-3">
                <b-spinner label="Loading..." :hidden="!uploading_in_progress"></b-spinner>           
                <b-button class="mt-3" variant="primary" block @click="handleOk" :hidden="uploading_in_progress" :disabled="this.newPrototypeName.length < 3">Upload</b-button>
            </div>
        </b-modal>

    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data() {
        return {
            message: '',
            uploading_in_progress: false,
            perPage: 20,
            currentPage: 1,
            totalRows: null,
            prototypes: [],
            filter_by_prototype: null,
            filter_by_uuid: null,
            newPrototypeName: '',
            fields: [
                { key: 'name', class: 'text-center align-middle' },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
            ]
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        init() {
            this.download_list_of_prototypes()
        },
        download_list_of_prototypes() {
            this.$http.get(this.$apiURL + '/admin/prototypes',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: this.filter_by_prototype, uuid: this.filter_by_uuid }
                })
                .then((res) => {
                    this.prototypes = res.data
                    this.totalRows = this.prototypes.length
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.createNewPrototype()
        },
        createNewPrototype() {
            this.uploading_in_progress = true
            var formData = new FormData();
            formData.append('file', this.$refs.res_file.files[0]);
            formData.append('name', this.newPrototypeName);
            this.$http.post(this.$apiURL + '/admin/space_prototype/create',
                formData, {
                headers: Object.assign({}, this.$store.getters.authHeader, { 'Content-Type': 'multipart/form-data' })
            })
                .then((res) => {
                    this.$router.push({ name: "prototype", params: { uuid: res.data.uuid } })
                })
                .catch((error) => {
                    switch (error.response.status) {
                        case 409:
                            this.$router.push({ name: "prototype", params: { uuid: error.response.data.uuid, message: "Notice: gitlab repo already exists with this name" } })
                            break;
                        default:
                            this.newPrototypeName = '';
                            this.uploading_in_progress = false;
                            this.$bvModal.hide('modalPopover')
                            this.message = {
                                'message': error.response.data,
                                'type': "danger"
                            }
                    }

                });

            
        }
    },
    created() {
        this.init();
    },
}
</script>
